module.exports = require("@tiptap/extension-hard-break");